export function formatDate (value) {
  let format = value.split('-');
  return format[2] + '/' + format[1] + '/' + format[0];
}

export function isValidDate (value, birthday) {
  if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) {
    return false;
  }

  let parts = value.split('/');

  let day = parseInt(parts[0], 10);
  let month = parseInt(parts[1], 10);
  let year = parseInt(parts[2], 10);

  if (year < 1000 || year > 3000 || month == 0 || month > 12) {
    return false;
  }

  let monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

  if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) {
    monthLength[1] = 29;
  }

  if (day > 0 && day <= monthLength[month - 1]) {
    let date = new Date(`${month}/${day}/${year}`);
    let today = new Date();
    date.setHours(0,0,0,0);
    today.setHours(0,0,0,0);
    if (birthday === true) {
      return +date <= +today;
    } else {
      return +date >= +today;
    }
  }

  return false;
}


// WEBPACK FOOTER //
// ./src/methods/helpers.js